import { useMutation } from "react-query";
import { addSingleDoorBuzzer } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleDoorBuzzer = () => {
  return useMutation(addSingleDoorBuzzer);
};
export default useAddSingleDoorBuzzer;
